// ── Days / hours helpers (mirrors TimesheetGrid) ─────────────────────────────
export const ALL_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;
export const ALL_DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export type ApprovalDay = typeof ALL_DAYS[number];

export function buildDaysFromStart(
  weekStartDay: 0 | 1 | 2 | 3 | 4 | 5 | 6,
  workingDays?: Record<string, { isWorkingDay: boolean }>
) {
  const days: ApprovalDay[] = [];
  const labels: string[] = [];
  for (let i = 0; i < 7; i++) {
    const idx = (weekStartDay + i) % 7;
    const day = ALL_DAYS[idx];
    if (workingDays) {
      if (workingDays[day]?.isWorkingDay) {
        days.push(day);
        labels.push(ALL_DAY_LABELS[idx]);
      }
    } else if (day !== 'saturday' && day !== 'sunday') {
      days.push(day);
      labels.push(ALL_DAY_LABELS[idx]);
    }
  }
  return { days, labels };
}

export function isWeekendDay(day: ApprovalDay): boolean {
  return day === 'saturday' || day === 'sunday';
}
